import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'react-map-gl';

import { useSelector } from 'react-redux';
import { selectMapData } from '../../../store/data/data.selector';
import {
  selectIsClimate,
  selectAttributeId,
  selectHazardMetric,
} from '../../../store/options/options.selector';
import { selectDateRange } from '../../../store/options/options.selector';

import {
  getStateAbbr,
  cityOverrides,
} from '../../../store/constants/locationInfo';
import {
  getAttributeText,
  getHazardNumber,
  getClimateNumber,
} from '../../../utilities/mapPopupText';

import './map-popup.styles.scss';

export default function MapPopup({ popupData }) {
  const { isState, id, name, state, latitude, longitude } = popupData;
  const isClimate = useSelector(selectIsClimate);
  const attribute = useSelector(selectAttributeId);
  const hazardMetric = useSelector(selectHazardMetric);
  const data = useSelector(selectMapData);
  const dateRange = useSelector(selectDateRange);

  const opt = isClimate ? attribute : hazardMetric;
  const { attrName, unit, popupUnit } = getAttributeText(isClimate, opt);
  const formattedUnits = isClimate ? popupUnit + ' per decade' : unit;
  const number = isClimate
    ? getClimateNumber(isState, data, id)
    : getHazardNumber(isState, data, hazardMetric, id);
  const rangeText = (
    <span>
      {' '}
      between <b>{dateRange.start}</b> and <b>{dateRange.end}</b>.
    </span>
  );
  const locationText = (
    <b>
      {name}
      {isState || state === '11'
        ? ''
        : cityOverrides.includes(id)
        ? ' City'
        : ' County'}
    </b>
  );

  let text = '';
  if (isClimate) {
    text = (
      <p>
        {' '}
        In {locationText} the {attrName} has changed by <b>{number}</b>{' '}
        {formattedUnits} {rangeText}
      </p>
    );
  } else {
    let t =
      attrName === 'Total Reported Episodes'
        ? ' reported events'
        : ` ${formattedUnits} of reported ${attrName
            .split(' ')
            .slice(2)
            .join(' ')
            .toLowerCase()}`;
    text = (
      <p>
        {locationText}
        {isState ? '' : <b>, {getStateAbbr(state)}</b>} has experienced{' '}
        <b>{formattedUnits === '' ? '$' : ''}</b>
        <b>{number}</b> {t} {rangeText}
      </p>
    );
  }

  return (
    <Popup
      tipSize={5}
      longitude={longitude}
      latitude={latitude}
      closeOnClick={false}
      closeButton={false}
      style={{ zIndex: 1 }}
      offset={{
        'bottom': [0,-10],
        'top': [0,10]
      }}
    >
      {text}
    </Popup>
  );
}

MapPopup.propTypes = {
  popupData: PropTypes.object,
};
